import { connect } from 'react-redux';

import { setDetailPanelTarget } from '@store/actions/ux';
import { requestProgramDetails } from '@tvguide/store/actions/requests';
import ProgramHighlight from './programhighlight';

const mapStateToProps = state => ({
  nid: state.ux.nid,
  channels: state.channels,
});

const mapDispatchToProps = dispatch => ({
  openDetailPanel: (sid, id, pid) => {
    dispatch(setDetailPanelTarget(id));
    dispatch(requestProgramDetails(sid, id, pid));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProgramHighlight);
